(function(){
  if (window.AUVENNESetConfiguratorBound) return;
  window.AUVENNESetConfiguratorBound = true;
  var AUV_IS_SV = (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0;
  function auvUi(nl, sv){ return AUV_IS_SV ? sv : nl; }

  function rootPath(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function formatMoney(cents){
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    try { return new Intl.NumberFormat(AUV_IS_SV ? 'sv-SE' : 'nl-NL',{style:'currency',currency:currency}).format(amount); }
    catch (error) { return '€' + amount.toFixed(2).replace('.',','); }
  }

  function getVariants(picker){
    if (picker._auvVariants) return picker._auvVariants;
    var node = picker.querySelector('[data-auv-variants]');
    if (!node) return [];
    try { picker._auvVariants = JSON.parse(node.textContent || '[]'); }
    catch (error) { picker._auvVariants = []; }
    return picker._auvVariants;
  }

  function selectedValues(picker){
    return Array.prototype.slice.call(picker.querySelectorAll('[data-auv-option-index]'))
      .sort(function(a,b){ return Number(a.dataset.auvOptionIndex) - Number(b.dataset.auvOptionIndex); })
      .map(function(node){ return node.tagName === 'SELECT' ? node.value : node.dataset.auvValue; });
  }

  function resolveVariant(picker){
    var values = selectedValues(picker);
    var variants = getVariants(picker);
    var match = variants.find(function(variant){
      return variant.available === true && Array.isArray(variant.options) && variant.options.length === values.length && variant.options.every(function(value,index){
        return String(value) === String(values[index]);
      });
    });
    var status = picker.querySelector('[data-auv-picker-status]');
    var price = picker.querySelector('[data-auv-picker-price]');
    if (match) {
      picker.dataset.auvSelectedVariant = String(match.id);
      if (status) status.textContent = '';
      if (price && match.price != null) price.textContent = formatMoney(match.price);
      var card=picker.closest('[data-auv-set-card]');
      var index=Array.from(card.querySelectorAll('[data-auv-product-config]')).indexOf(picker);
      var visual=card.querySelectorAll('.auv-look__visual')[index];
      if(visual){visual.href=match.url;var image=visual.querySelector('img');if(image&&match.image){image.src=match.image;image.removeAttribute('srcset');image.alt=picker.querySelector('strong').textContent+' — '+selectedValues(picker).join(' / ');}}

      return match;
    }
    delete picker.dataset.auvSelectedVariant;
    if (status) status.textContent = auvUi('Deze combinatie is momenteel niet beschikbaar.', 'Den här kombinationen är inte tillgänglig just nu.');
    return null;
  }

  function updateSetPricing(card,resolved){
    if (!card || !resolved.length || resolved.some(function(item){ return !item || item.price == null; })) return;
    var total = resolved.reduce(function(sum,item){ return sum + (Number(item.price) || 0); },0);
    var rate = Math.max(0,Math.min(100,Number(card.dataset.auvSetRate) || 0));
    var discounted = Math.round(total * (100 - rate) / 100);
    var saving = total - discounted;
    var count = Number(card.dataset.auvSetCount) || resolved.length;

    var before = card.querySelector('[data-auv-set-price-before]');
    var after = card.querySelector('[data-auv-set-price-after]');
    var savingNode = card.querySelector('[data-auv-set-saving]');
    if (before) before.textContent = formatMoney(total);
    if (after) after.textContent = formatMoney(discounted);
    if (savingNode) savingNode.textContent = formatMoney(saving);

    var toggle = card.querySelector('[data-auv-set-toggle]');
    var panel = card.querySelector('[data-auv-set-config]');
    var closedLabel = auvUi('Kies ', 'Välj ') + count + auvUi(' — bespaar ', ' — spara ') + formatMoney(saving) + ' →';
    if (toggle) {
      toggle.dataset.auvClosedLabel = closedLabel;
      if (!panel || panel.hidden) toggle.textContent = closedLabel;
    }

    var confirm = card.querySelector('[data-auv-set-confirm]');
    if (confirm) {
      var readyLabel = (count === 3 ? auvUi('Voeg trio toe', 'Lägg till trio') : auvUi('Voeg duo toe', 'Lägg till duo')) + auvUi(' — bespaar ', ' — spara ') + formatMoney(saving) + ' →';
      confirm.dataset.auvReadyLabel = readyLabel;
      if (confirm.dataset.loading !== 'true') confirm.textContent = readyLabel;
    }
  }

  function refreshCard(card){
    var pickers = Array.prototype.slice.call(card.querySelectorAll('[data-auv-product-config]'));
    var resolved = pickers.map(resolveVariant);
    var confirm = card.querySelector('[data-auv-set-confirm]');
    if (confirm) {
      var ready = pickers.length >= 2 && resolved.length === pickers.length && resolved.every(Boolean);
      confirm.disabled = !ready;
      confirm.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    updateSetPricing(card,resolved);
    return resolved;
  }

  function setToggleLabel(button, open){
    button.textContent = open ? button.dataset.auvOpenLabel : button.dataset.auvClosedLabel;
  }

  document.addEventListener('click', function(event){
    var toggle = event.target.closest('[data-auv-set-toggle]');
    if (toggle) {
      if (toggle.disabled) return;
      event.preventDefault();
      var card = toggle.closest('[data-auv-set-card]');
      if (!card) return;
      var panel = card.querySelector('[data-auv-set-config]');
      if (!panel) return;
      var opening = panel.hidden;
      panel.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      setToggleLabel(toggle, opening);
      if (opening) {
        refreshCard(card);
        window.requestAnimationFrame(function(){ panel.scrollIntoView({behavior:'smooth',block:'nearest'}); });
      }
      return;
    }

    var confirm = event.target.closest('[data-auv-set-confirm]');
    if (!confirm || confirm.disabled || confirm.dataset.loading === 'true') return;
    event.preventDefault();

    var card = confirm.closest('[data-auv-set-card]');
    if (!card) return;
    var resolved = refreshCard(card);
    if (!resolved.length || resolved.some(function(item){ return !item; })) return;

    var status = card.querySelector('[data-auv-set-status]');
    var originalLabel = confirm.dataset.auvReadyLabel || confirm.textContent;
    confirm.dataset.loading = 'true';
    confirm.disabled = true;
    confirm.textContent = auvUi('Toevoegen…', 'Lägger till…');
    if (status) status.textContent = '';

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionIds = cartDrawer.getSectionsToRender().map(function(section){ return section.id; });
    }
    var payload = {
      items: resolved.map(function(variant){ return {id:variant.id,quantity:1}; })
    };
    if (sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname + window.location.search;
    }

    fetch(rootPath() + 'cart/add.js', {
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(payload)
    })
    .then(function(response){
      return response.json().then(function(data){ if (!response.ok) throw data; return data; });
    })
    .then(function(data){
      confirm.textContent = auvUi('Toegevoegd ✓', 'Tillagt ✓');
      if (status) status.textContent = auvUi('De complete combinatie staat in je winkelmand.', 'Hela kombinationen finns nu i din varukorg.');

      if (window.AUVENNECartDrawer && typeof window.AUVENNECartDrawer.render === 'function') {
        window.AUVENNECartDrawer.render(data, confirm);
      } else if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      }

      window.setTimeout(function(){
        confirm.dataset.loading = 'false';
        confirm.disabled = false;
        confirm.textContent = confirm.dataset.auvReadyLabel || originalLabel;
      }, 900);
    })
    .catch(function(){
      confirm.dataset.loading = 'false';
      confirm.disabled = false;
      confirm.textContent = confirm.dataset.auvReadyLabel || originalLabel;
      if (status) status.textContent = auvUi('Kon de complete set niet toevoegen. Controleer je keuzes en probeer opnieuw.', 'Det gick inte att lägga till hela setet. Kontrollera dina val och försök igen.');
    });
  });

  document.addEventListener('change', function(event){
    if (!event.target.matches('[data-auv-option-index]')) return;
    var card = event.target.closest('[data-auv-set-card]');
    if (card) refreshCard(card);
  });

  function init(){
    document.querySelectorAll('[data-auv-set-card]').forEach(function(card){ refreshCard(card); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
